import React from 'react'
import NavBar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { motion } from 'framer-motion';
import { useState} from 'react';
import Divider from '@mui/material/Divider';
import TermsofuseList from '../components/TermsofuseList';

const Legal = () =>  {
    const [isOpen, setIsOpen] = useState(false)

    const toggle =() =>{
      setIsOpen(!isOpen)
    };
    return (
        <body class="">

            <div class="wrapper">

                 <Sidebar isOpen={isOpen} toggle={toggle}/>
                <NavBar toggle={toggle}/>

                <motion.div 
                    layout
                    initial={{opacity:0}}
                    animate={{opacity:1}}
                    transition={{delay:1}}
                    >
                    <div class='container hero'>
                        <h1>Legal</h1>
                    </div>

                    <Divider/>

                    <div className='paragragh-wrap'>

                        <h1 className='paragragh-text-h1'>Terms of use</h1>
                        <TermsofuseList/>
                    </div>

                    <Divider/>
                
                </motion.div>


             </div>
        </body>
    )
}

export default Legal
